// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wKYs","select":"styles_select__16DBV"};